import { CSS_BREAKPOINTS } from '@cloud-ru/uikit-product-utils';
import { getCurrentBackground, getCurrentLogo } from '#utils/theme';
export const injectPreloadLink = href => {
  const head = document.querySelector('head');
  if (!head) {
    return;
  }
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'image';
  link.href = href;
  head.appendChild(link);
};
export const preloadImages = async (clientId, themeConfig) => {
  const logoLink = getCurrentLogo(themeConfig);
  if (logoLink) {
    injectPreloadLink(logoLink);
  }
  const withoutBackgroundImage = matchMedia(CSS_BREAKPOINTS.tablet).matches;
  if (withoutBackgroundImage) {
    return;
  }
  const backgroundLink = getCurrentBackground({
    clientId,
    themeConfig
  });
  if (backgroundLink) {
    injectPreloadLink(backgroundLink);
  }
};